import * as React from 'react';
import { css } from '@emotion/core';

import { useStateBus } from '~/state/bridge';
import { dispatch as emit } from '~/emitter';
import { getLeadFormSelected, getLeadAdEnabled } from '~/state/LeadAds/selectors';

import Button from '~/theseus/components/Button';
import { getAdType } from '~/state/Campaign/selectors';

interface Props {
  onPost: () => void;
}

export function PostButton(props: Props) {
  const { onPost } = props;

  const adType = useStateBus(getAdType);
  const leadAdEnabled = useStateBus(getLeadAdEnabled);
  const leadAdSelected = useStateBus(getLeadFormSelected);

  const buttonContent = React.useMemo(() => {
    switch (adType) {
      default:
      case 'boosted':
        return 'Post to Facebook and Boost';
      case 'post_only':
        return 'Post to Facebook';
      case 'ad_only':
        return 'Create Ad on Facebook';
    }
  }, [adType]);

  const handlePostAd = React.useCallback((e: React.SyntheticEvent) => {
    e.preventDefault();

    if (leadAdEnabled && !leadAdSelected) {
      emit({ type: 'needs-lead-ad' });
      return;
    }

    onPost();
  }, [onPost, leadAdSelected, leadAdEnabled]);

  return (
    <Button
      type="submit"
      variant="primary"
      size="lg"
      form="publish_ad"
      onClick={handlePostAd}
      disabled={adType === null}
      css={css`padding: 14px 26px;`}
    >
      { buttonContent }
    </Button>
  );
}
